export default "__VITE_ASSET__16ab4def__"